var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarDeleted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder_user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 18.5,
    cy: 18.5,
    r: 18.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "placeholder_user",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mann_02"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Oval-2",
    fill: "none",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7055556,30.9361111 C20.2533028,30.9361111 21.5774681,30.6037595 22.6927845,29.9841223 L22.6931374,31.4058777 C24.1576115,32.0150139 25.5044987,32.9075926 26.6497983,34.0490745 C28.9639364,36.3554988 30.2646296,39.4883201 30.2646296,42.7555556 L29.8877778,64.4074074 C29.8877778,71.0962465 24.8878461,71.9208041 18.2413824,71.9439277 L17.9381481,71.9444444 C11.147963,71.9444444 5.29648148,71.1975926 5.29648148,64.4074074 L5.63907407,42.7624074 C5.65473811,37.112102 9.46879968,32.355598 14.6631496,30.9123127 L14.6628855,29.9529868 C15.789686,30.5926194 17.1320827,30.9361111 18.7055556,30.9361111 Z M26.1131592,6 C27.9985889,7.63897907 28.8885498,10.4216683 28.8885498,12.12 L28.888735,12.6457918 C28.8867486,13.5345562 28.860268,14.4578352 28.6140137,15 C28.1094511,16.1108679 28.1094511,17.522583 27.9277344,17.522583 C27.9277344,17.522583 27.7041447,13.0350726 27.4896296,13.15 C27.3444907,13.2277589 27.18785,13.2631732 27.0206979,13.2621354 C26.2422151,9.85379738 24.5515571,7.93246208 22.3837845,7.01912041 C22.734401,6.49379136 23.153162,6.12122923 23.2585449,6 C23.5350998,5.68185999 23.8206789,4.00717732 26.1131592,6 Z M22.5377197,4 C23.7786319,5.29862721 23.4729094,5.30823058 22.2839355,6.65049952 C22.2061296,6.73833702 22.1360908,6.82097586 22.0723091,6.89914578 C21.0366838,6.51232386 19.8988996,6.34481481 18.7055556,6.34481481 C14.7959519,6.34481481 11.4826908,8.12494175 10.3438746,13.4605607 C10.329938,13.4753434 10.3209201,13.4896978 10.3161621,13.503418 C9.77223711,15.0718872 9.92148148,17.4581604 9.68557739,17.4581604 C9.68557739,17.4581604 9.85211182,15.4823688 8.76400757,14.9502869 C7.67590332,14.4182049 7.50534374,14.467918 7.79272461,12.12 C8.1105957,9.52297507 8.76831055,7.71523405 11.5432129,5 C14.3181152,2.28476595 20.6996031,2.07639223 22.5377197,4 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.37037037,
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7055556,4.28925926 C13.8544444,4.28925926 9.92148148,8.22757523 9.92148148,15.217963 C9.92148148,22.9194444 13.5152588,28.1953704 18.7055556,28.1953704 C23.8958523,28.1953704 27.4896296,22.9194444 27.4896296,15.217963 C27.4896296,8.2586896 23.5566667,4.28925926 18.7055556,4.28925926 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 1.37037037,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 8.5,
    cy: 17.5,
    rx: 1.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 28.5,
    cy: 17.5,
    rx: 1.5,
    ry: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDeleted);
export default __webpack_public_path__ + "static/media/avatar_deleted.fdc87c6b13f5b2d2131a09e7ef8b0b67.svg";
export { ForwardRef as ReactComponent };